module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-7c6844e8c266e7c6ecbdcb7fdc1492c6.webp";